import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function TimeOfUse({ slots = [] }: { slots?: any[] }) {
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const currency = useCurrency();
  const safeSlots = Array.isArray(slots) ? slots : [];

  const getSlotForHour = (hour: number) => {
    return safeSlots.find((s: any) => {
      const formatTimeStr = (timeVal: any) => {
        if (!timeVal) return "00:00";
        if (typeof timeVal === 'string' && timeVal.includes(':')) return timeVal;
        const num = Number(timeVal) || 0;
        const h = Math.floor(num);
        const m = Math.round((num - h) * 60);
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      };

      const startStr = formatTimeStr(s.startTime ?? s.start_time);
      const endStr = formatTimeStr(s.endTime ?? s.end_time);
      
      const fromParts = startStr.split(':');
      const toParts = endStr.split(':');
      
      const fromHour = parseInt(fromParts[0], 10);
      const fromMinute = parseInt(fromParts[1], 10);
      const toHour = parseInt(toParts[0], 10);
      const toMinute = parseInt(toParts[1], 10);
      
      let isCovered = false;
      
      if (fromHour <= toHour) {
         if (hour > fromHour && hour < toHour) {
           isCovered = true;
         } else if (hour === fromHour && hour === toHour) {
           if (toMinute > fromMinute) isCovered = true;
         } else if (hour === fromHour) {
           isCovered = true;
         } else if (hour === toHour && toMinute > 0) {
           isCovered = true;
         }
      } else {
         // Cross midnight
         if (hour >= fromHour || hour < toHour || (hour === toHour && toMinute > 0)) {
           isCovered = true;
         }
      }
      
      return isCovered;
    });
  };

  return (
    <div className="space-y-4">
      {/* Timeline */}
      <div className="flex w-full overflow-hidden rounded-md border border-slate-200">
        {hours.map((hour) => {
          const slot = getSlotForHour(hour);
          const color = slot?.color || '#e2e8f0';
          return (
            <div
              key={hour}
              className="relative flex-1 border-r border-white last:border-r-0 py-2 text-center text-xs font-medium text-slate-700"
            >
              <div className="absolute inset-0 opacity-20" style={{ backgroundColor: color }} />
              <span className="relative z-10">{String(hour).padStart(2, '0')}</span>
            </div>
          );
        })}
      </div> 

      {/* List */}
      <div className="rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-left text-xs">
          <thead className="bg-slate-50 font-semibold text-slate-500">
            <tr>
              <th className="px-4 py-3 tracking-wider">Slot</th>
              <th className="px-4 py-3 tracking-wider">Hours</th>
              <th className="px-4 py-3 text-right tracking-wider">Rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {safeSlots.map((slot: any, index: number) => {
              const formatTimeStr = (timeVal: any) => {
                if (!timeVal) return "00:00";
                if (typeof timeVal === 'string' && timeVal.includes(':')) return timeVal;
                const num = Number(timeVal) || 0;
                const h = Math.floor(num);
                const m = Math.round((num - h) * 60);
                return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
              };
              const start = formatTimeStr(slot.startTime ?? slot.start_time ?? 0);
              const end = formatTimeStr(slot.endTime ?? slot.end_time ?? 0);
              return (
                <tr key={index}>
                  <td className="px-4 py-2.5 font-semibold text-slate-800">
                    <div className="flex items-center gap-2.5">
                      <div
                        className="h-3 w-3 rounded-[3px]"
                        style={{ backgroundColor: slot.color || '#cbd5e1' }}
                      />
                      {slot.name || slot.slotName || "N/A"}
                    </div>
                  </td>
                  <td className="px-4 py-2.5 font-mono text-xs font-medium text-slate-500">
                    {start} &rarr; {end}
                  </td>
                  <td className="px-4 py-2.5 text-right font-semibold text-slate-800">
                    {currency} {slot.rate ?? 0} <span className="font-normal text-slate-400 ml-1">{slot.unit || "N/A"}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
